import { ScrollView, Text, View, useColorScheme } from 'react-native';
import React, {Suspense, memo, lazy} from 'react';
import DefaultScreen from '@components/Global/DefaultScreenView';
import MenuIconCard from '@components/Global/MenuIconCard';
import { useTranslation } from 'react-i18next';
import { XStack } from 'tamagui';

const AnimatedLottieView = lazy(() => import('@utils/lottieAnimation'));

const LazyLottieView = (props) => (
  <Suspense fallback={<View />}>
    <AnimatedLottieView {...props} />
  </Suspense>
);

const DataMenu = ({navigation}) => {
  const { t } = useTranslation();
  return (
    <DefaultScreen style={{ paddingLeft: 2, paddingRight: 3 }}>
      <XStack flexWrap='wrap' gap={20} columnGap={20} style={{ gap: 5, marginBottom: 150, alignSelf: 'stretch', flexDirection: 'row', flexWrap: 'wrap' }}>
        <MenuIconCard pressFunction={() => {
          navigation.navigate('DataStore')}} subtitle={`${t('BrowseDataSub')}
          `} cardTitle={`${t('BrowseData')}`}>
          <LazyLottieView source={require('@assets/animations/magnifExample.json')} loop={false} style={{ width: '100%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard>
        <MenuIconCard pressFunction={() => navigation.navigate('CreateData')} subtitle={`${t('CreateDataSub')}`} cardTitle={`${t('CreateData')}`}>
          <LazyLottieView source={require('@assets/animations/114389-upload.json')} loop={false} style={{ width: '100%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard>
        <MenuIconCard pressFunction={() => navigation.navigate('Upload')} subtitle={`${t('ImportDataSub')}`} cardTitle={`${t('ImportData')}`}>
          <LazyLottieView source={require('@assets/animations/114459-download-file-icon-animation.json')} loop={false} style={{ width: '80%', height: 70, justifyContent: 'center', alignSelf: 'center' }} autoPlay />
        </MenuIconCard>
        <MenuIconCard beta pressFunction={() => {
          navigation.navigate('BubbleScreen')
        }} subtitle={`${t('BubbleScreenSub')}
          `} cardTitle={`${t('BubbleScreen')}`}>
          <LazyLottieView source={require('@assets/animations/magnifExample.json')} loop={false} style={{ width: '100%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard>
        <MenuIconCard pressFunction={() => navigation.navigate('DataFavourites')} subtitle={`${t('FavouriteDataSub')}`} cardTitle={`${t('FavouriteData')}`}>
          <LazyLottieView source={require('@assets/animations/star.json')} loop={false} style={{ width: '80%', height: 70, justifyContent: 'center', alignSelf: 'center' }} autoPlay />
        </MenuIconCard>
        <MenuIconCard pressFunction={() => navigation.navigate('DataTemplates')} subtitle={`${t('DataTemplatesSub')}`} cardTitle={`${t('DataTemplates')}`}>
          <LazyLottieView source={require('@assets/animations/42404-add-document.json')} loop={false} style={{ width: '100%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard>
        <MenuIconCard beta pressFunction={() => navigation.navigate('FlowStack')} subtitle={`${t('flowTemplateSub')}`} cardTitle={`${t('flowTemplates')}`}>
          <LazyLottieView source={require('@assets/animations/flow.json')} loop={true} style={{ width: '100%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard>        
        <MenuIconCard pressFunction={() => navigation.navigate('PublicData')} subtitle={`${t('PublicDataSub')}`} cardTitle={`${t('PublicData')}`}>
          <LazyLottieView source={require('@assets/animations/public_dataset.json')} loop={false} style={{ width: '100%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard>
      </XStack>
    </DefaultScreen >
  )
}
export default memo(DataMenu);